// extracted by mini-css-extract-plugin
export var buttons = "SliderControllers-module--buttons--be07d";
export var controls = "SliderControllers-module--controls--c0cbe";
export var pageIndex = "SliderControllers-module--page-index--4f8ab";